import { gql } from 'graphql-request'

export const UPDATE_BOOK_COLLECTION = gql`
  mutation UpdateBookCollection(
    $updateBookCollectionInput: UpdateBookCollectionInput!
  ) {
    updateBookCollection(
      updateBookCollectionInput: $updateBookCollectionInput
    ) {
      message
    }
  }
`
